import React from "react";
import { Form, message } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory, Redirect } from "react-router-dom";
import FieldRenderer from "../components/field-renderer";
import { authRoutesUrls } from "Layouts/AuthLayout/PublicRoutes";
import AppButton from "components/ui/AppButton";
import { resetPasswordFields } from "../utils/fields";
import AuthLayout from "../layout";
import { API } from "api";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [form] = Form.useForm();
  const router = useHistory();

  const handleSubmit = async(values) => {
    message.destroy();
    setLoading(true);
    const result = await API.NEW_PASSWORD({
      phoneNumber: router.location.state.phoneNumber,
      verificationCode: values?.code,
      password: values?.password,
    });
    if (result && result.success === 1) {
      message.success(
        result?.message ?? t("Your Passsword has been changed, please login")
      );
      router.push(authRoutesUrls.login);
    } else {
      message.error(result?.message);
    }
    setLoading(false);
  };

  if(!router?.location?.state?.phoneNumber) {
    return <Redirect to={authRoutesUrls.login} />;
  }

  return (
    <AuthLayout
      loading={loading}
      title={t("Reset Password")}
      description={t("Enter your new password")}
    >
      <Form form={form} onFinish={handleSubmit}
      initialValues={{
        password: "",
        confirmPassword: "",
        code: "",
      }}
      name="reset-password-form"
      layout="vertical"
      autoComplete="off"
      id="reset-password-form"
      >
        {resetPasswordFields(t, form).map((field) => (
          <Form.Item key={field.typeKey} name={field.name} rules={field.rules}>
            <FieldRenderer field={field} />
          </Form.Item>
        ))}
      </Form>
      <AppButton type="submit" form="reset-password-form" className="w-full">
        {t("Reset Password")}
      </AppButton>
    </AuthLayout>
  );
};

export default ResetPassword;
